import { lazy, Suspense, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Route, Switch } from "react-router-dom";
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
// components
import LazyLoader from './components/LazyLoader';
import { loadUser } from './redux/User/user.actions';
import PrivateRoute from './Routing/PrivateRoute';
import { setToken } from './utils/setToken';

// pages
const HomePage = lazy(() => import('./pages/Homepage'))
const Searchpage = lazy(() => import('./pages/Searchpage'))
const YourExperiencePage = lazy(() => import('./pages/YourExperience'));
const EventPage = lazy(() => import('./pages/Eventpage'));
const CreateEventPage = lazy(() => import('./pages/CreateEvent'))

function App(props) {
  const { currentUser } = props;
  const dispatch = useDispatch();

  useEffect(() => {

    if (localStorage.authToken) {
      setToken(localStorage.authToken)
      dispatch(loadUser());

    }

    return () => null;
    // eslint-disable-next-line
  }, [])
  if (!currentUser && localStorage.authToken) {
    return <LazyLoader />
  }

  return (
    <div className="App">
      <Suspense fallback={<LazyLoader />}>
        <Header />
        <div className="main-content">
          <Switch>
            <Route exact path="/" component={HomePage} />
            {/* <Route exact path="/" component={EventPage} /> */}
            <PrivateRoute exact path="/host-events">
              <EventPage />
            </PrivateRoute>
            <PrivateRoute exact path="/your-experiences">
              <YourExperiencePage />
            </PrivateRoute>
            <Route exact path="/create-event" component={CreateEventPage} />
            <Route exact path="/search" component={Searchpage} />


            {/* Test thing below */}
            {/* <Route exact path="/host-events" component={() => <EventPage authorized={false}/>} /> */}

          </Switch>

        </div>
        <Footer />
      </Suspense>


    </div>
  );
}
const mapStateToProps = ({ User }) => ({
  currentUser: User.currentUser
})
export default connect(mapStateToProps, { loadUser })(App);
